import { render } from "react-dom";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import { CssBaseline } from "@mui/material";
import autoBind from "auto-bind";
import { ExperimentController } from "./index.controller";
import { View } from "./utils/view";

import "./index.css";

import { ThemeProvider } from "@emotion/react";
import { ExperimentBody } from "./body/body.component";
import { LoadingScreen } from "./components/loading-screen/loading-screen.component";
import { LoadErrorScreen } from "./components/manifest-error-screen/manifest-error-screen.component";
import { ExperimentState } from "./index.models";
import { theme } from "./index.theme";

const container = document.getElementById("root");

class ExperimentContainer extends View<
  any,
  ExperimentState,
  ExperimentController
> {
  constructor(props: any) {
    super(props, new ExperimentController());
    autoBind(this);
  }

  render() {
    let screen;

    if (this.state.error != null) {
      screen = (
        <LoadErrorScreen
          error={this.state.error}
          contact={this.state.contact}
          exception={this.state.exception}
        />
      );
    } else if (this.state.loading) {
      screen = <LoadingScreen />;
    } else {
      screen = (
        <ExperimentBody
          mobileSupported={this.state.mobileSupported}
          branding={this.state.branding}
          shortcuts={this.state.shortcuts}
          menuController={this.state.menuController}
          notificationCount={this.props.notificationCount}
          version={this.state.version}
          posts={this.state.posts}
          driver={this.controller.getNetworkDriver()}
          testId={this.controller.getTestId()}
          unsupportedFeatureController={this.state.unsupportedFeatureController}
          sponsored={this.state.sponsored}
          birthdays={this.state.birthdays}
          contacts={this.state.contacts}
          showContacts={this.state.showContacts}
          leaderboard={this.state.leaderboard}
          onlineUsers={this.state.onlineUsers}
          user={this.state.user}
        />
      );
    }

    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {screen}
      </ThemeProvider>
    );
  }
}

render(<ExperimentContainer />, container);
